import React from "react";
import {useSelector} from "react-redux";
import {Redirect} from "react-router-dom";

const HomePage = () => {
    const account  = useSelector(state => state.account)
    const { perimetersV2, selectedPerimeter } = useSelector(state => state.extranet)

    React.useLayoutEffect(() => {

    }, [account])

    const setDefaultPerimeter = () => {
        const index = 0;
    }

    if (account) {
        if (account.user?.type === "ASSURE") {
            return <Redirect to={{
                pathname: "/ui/decomptes",
            }} />
        } else {

            if (perimetersV2.length === 1) {
                if (selectedPerimeter === null) {
                    setDefaultPerimeter();
                    return <Redirect to={{
                        pathname: "/ui/decomptes",
                    }} />
                } else {
                    return <Redirect to={{
                        pathname: "/ui/decomptes",
                    }} />
                }
            } else if (perimetersV2.length > 1) {
                return <Redirect to={{
                    pathname: "/ui/decomptes",
                }} />
            } else {
                console.log("Aucun perimètre")
                return null;
            }
        }
    } else {
        return 'loading new case ... !'
    }


}

export default HomePage
